// Single source of truth for the visible app version.
// Used in LoginPage, footers, and anywhere else we need to display the build.
export const APP_VERSION = "v1.4.1-pv-srt-mobile-paddleocr";
export const APP_NAME = "ParkingVision AI";

// Short version is shown in compact footers (mobile, sidebars, etc).
export const APP_VERSION_SHORT = "v1.4.1";

export default APP_VERSION;
